import type { FetchTrackingCallDetails } from './typings'
import type { CallTrackingResponse } from '../../typings'

export const fetchTrackingCallDetailsActionCreator = (
  payload: CallTrackingResponse,
): FetchTrackingCallDetails => ({
  type: 'trackingCall/fetchDetails',
  payload,
})
